import { apiFetch } from "../utils/apiFetch";
import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import StatusChangePopup from "./StatusChangePopup";
import RemoveMembers from "./RemoveMembers";
import { RxExit } from "react-icons/rx";
import WorkspaceLeave from "./WorkspaceLeave";

const WorkspaceMembers = ({
  workspace,
  members,
  setMembers,
  userId,
  userInfo,
  statusChange,
  setStatusChange,
  memberRemovePopup,
  setMemberRemovePopup,
  setWorkspaceMembersPopUp,
}) => {
  const [workspaceLeavePopUp, setWorkspaceLeavePopUp] = useState(null);
  const currentUserRole = members?.find(
    (member) => String(member.userId._id) === String(userId),
  )?.role;

  const selectedValues = members?.map((member) => member.role);

  useEffect(() => {
    const fetchMembers = async () => {
      try {
        const res = await apiFetch(
          `${process.env.API_URL}/api/workspace/manageMembers/${workspace._id}`,
          {
            method: "GET",
            },
        );

        if (!res.ok) {
          const errorText = await res.text();
          throw new Error(errorText + `: ${res.status}`);
        }
        const data = await res.json();
        console.log("members", data);
        setMembers(data);
      } catch (err) {
        alert(err.message);
      }
    };
    fetchMembers();
  }, []);

  return !members ? (
    <h1>Loading...</h1>
  ) : (
    <div
      onClick={() => setWorkspaceMembersPopUp(false)}
      className="fixed inset-0 bg-black/40 flex justify-center items-center z-50"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="w-[35dvw] h-[80dvh] bg-white rounded-lg p-6 overflow-y-auto"
      >
        <div className="flex flex-col gap-2 text-center sm:text-left">
          <h2 className="text-lg leading-none font-semibold">
            Group Members
          </h2>
          <p className="text-[#717182] text-sm">
            Invite new members and manage existing members in {workspace.name}{" "}
            Corporation
          </p>
        </div>
        <div className="flex-1 outline-none mt-4 overflow-y-auto">
          <div className="space-y-3 ">
            {members.map((member, index) => {
              return (
                <div
                  key={member.userId._id}
                  className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50"
                >
                  <div className="relative">
                    <span className="relative flex size-10 shrink-0 overflow-hidden rounded-full h-10 w-10">
                      <img
                        className="aspect-square size-full"
                        src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQhxtx5uOH2FwWtC_-HAnN75PQqBFgfLF9D2w&s"
                      ></img>
                    </span>
                  </div>
                  <div className="flex-1 min-w-0">
                    <p className="font-medium text-gray-900">
                      {member.userId.username}
                      {String(member.userId._id) === String(userId) && "(you)"}
                    </p>
                  </div>
                  <select
                    value={selectedValues[index]}
                    onChange={(e) =>
                      setStatusChange((prev) => {
                        return {
                          id: member.userId._id,
                          username: member.userId.username,
                          value: e.target.value,
                          index: index,
                        };
                      })
                    }
                    disabled={
                      currentUserRole === "member" ||
                      (currentUserRole === "admin" && member.role !== "member")
                    }
                    className={`inline-flex items-center justify-center rounded-md border px-2 py-0.5 text-xs font-medium w-fit whitespace-nowrap shrink-0 [&>svg]:size-3 gap-1 [&>svg]:pointer-events-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive transition-[color,box-shadow] overflow-hidden [a&]:hover:bg-secondary/90 ${member.role === "owner" ? "bg-purple-100 text-purple-800 border-purple-200" : member.role === "admin" ? "bg-blue-100 text-blue-800 border-blue-200" : "bg-gray-100 text-gray-800 border-gray-200"} ${
                      currentUserRole === "member" ||
                      (currentUserRole === "admin" && member.role !== "member")
                        ? "cursor-not-allowed"
                        : ""
                    }`}
                  >
                    {(currentUserRole === "owner" ||
                      String(member.userId._id) !== String(userId)) && (
                      <option value={"owner"}>Owner</option>
                    )}
                    <option value={"admin"}>Admin</option>
                    <option value={"member"}>Member</option>
                  </select>
                  {String(member.userId._id) === String(userId) ? (
                    <button
                      onClick={() =>
                        setWorkspaceLeavePopUp((prev) => {
                          return {
                            currentUserRole,
                            id: member.userId._id,
                            username: member.userId.username,
                          };
                        })
                      }
                      className="h-8 w-8 flex justify-center items-center hover:bg-red-50"
                    >
                      <RxExit className="text-red-600 " />
                    </button>
                  ) : (
                    <button
                      onClick={() =>
                        setMemberRemovePopup((prev) => {
                          return {
                            id: member.userId._id,
                            username: member.userId.username,
                          };
                        })
                      }
                      disabled={
                        currentUserRole === "member" ||
                        (currentUserRole === "admin" &&
                          member.role !== "member")
                      }
                      className={`inline-flex items-center justify-center whitespace-nowrap text-sm font-medium transition-all  disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive dark:hover:bg-accent/50 rounded-md gap-1.5 has-[>svg]:px-2.5 h-8 w-8 p-0 text-red-600 hover:text-red-700 hover:bg-red-50 ${
                        currentUserRole === "member" ||
                        (currentUserRole === "admin" &&
                          member.role !== "member")
                          ? "cursor-not-allowed"
                          : ""
                      }`}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="lucide lucide-user-minus h-4 w-4"
                        data-fg-bnbt55="201.56:217.1579:node_modules/lucide-react:160:25:5829:33:e:UserMinus::::::DOyx"
                        data-fgid-bnbt55=":rnu:"
                      >
                        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle cx="9" cy="7" r="4"></circle>
                        <line x1="22" x2="16" y1="11" y2="11"></line>
                      </svg>
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        {statusChange && (
          <StatusChangePopup
            statusChange={statusChange}
            setStatusChange={setStatusChange}
            workspace={workspace}
            userId={userId}
            currentUserRole={currentUserRole}
          />
        )}
        {memberRemovePopup && (
          <RemoveMembers
            setMemberRemovePopup={setMemberRemovePopup}
            memberRemovePopup={memberRemovePopup}
            setMembers={setMembers}
            workspace={workspace}
          />
        )}
        {workspaceLeavePopUp && (
          <WorkspaceLeave
            currentUserRole={currentUserRole}
            setWorkspaceLeavePopUp={setWorkspaceLeavePopUp}
            workspaceLeavePopUp={workspaceLeavePopUp}
            workspace={workspace}
            setMembers={setMembers}
          />
        )}
      </div>
    </div>
  );
};

export default WorkspaceMembers;
